"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSafariVersion = getSafariVersion;
exports.isMacOS = exports.isIOS = void 0;
function getSafariVersion() {
  var browserVersion = function browserVersion(userAgent, regex) {
    return userAgent.match(regex) ? userAgent.match(regex)[2] : null;
  };
  var userAgent = navigator.userAgent;
  var browser = 'unkown';
  // Detect browser name
  browser = /safari/i.test(userAgent) && !/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i.test(userAgent) ? 'Safari' : browser;
  // detect browser version
  switch (browser) {
    case 'Safari':
      return "".concat(browser, "/").concat(browserVersion(userAgent, /(version)\/([\d\.]+)/i)).split('/')[1];
    default:
      return null;
  }
}

/**
 * Detects if the current device is running iOS
 * @returns {boolean} True if the device is running iOS
 */
var isIOS = exports.isIOS = function isIOS() {
  if (typeof window === 'undefined') {
    return false;
  }
  var userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent) ||
  // Detect iPad on iOS 13+ (which reports as Macintosh)
  userAgent.includes('macintosh') && 'ontouchend' in document;
};

/**
 * Detects if the current device is running macOS
 * @returns {boolean} True if the device is running macOS
 */
var isMacOS = exports.isMacOS = function isMacOS() {
  if (typeof window === 'undefined') {
    return false;
  }
  var userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.includes('macintosh') && !isIOS();
};
//# sourceMappingURL=browser.utils.js.map